var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95746 1.2389L6.68879 1.03265C6.3528 1.0021 6.18339 0.986696 6.02258 1.01466C5.87889 1.03964 5.74063 1.08954 5.61425 1.16234C5.47227 1.24412 5.35139 1.36501 5.11101 1.6054L1.88838 4.82819C1.39831 5.31828 1.15314 5.56346 1.06104 5.84692C0.979774 6.09705 0.979591 6.36693 1.06086 6.61706C1.15325 6.90142 1.40004 7.14852 1.89322 7.64172L4.35887 10.1075C4.85205 10.6007 5.09853 10.8469 5.38288 10.9393C5.633 11.0206 5.90256 11.0201 6.15268 10.9388C6.43702 10.8464 6.68345 10.6006 7.17663 10.1074L10.3913 6.89253C10.6339 6.64995 10.7552 6.52862 10.8373 6.38598C10.9101 6.2596 10.9602 6.12133 10.9852 5.97764C11.0134 5.81546 10.9979 5.64455 10.9669 5.3029L10.7614 3.04261C10.7079 2.4543 10.681 2.15997 10.553 1.92977C10.4402 1.72682 10.2729 1.5595 10.0699 1.44664C9.84091 1.31927 9.54867 1.29271 8.96625 1.23976L8.95746 1.2389Z",
    stroke: "#45436B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66981 4.33041C7.91298 4.57359 8.30723 4.57359 8.5504 4.33041C8.79357 4.08723 8.79357 3.69268 8.5504 3.4495C8.30723 3.20632 7.91307 3.20609 7.66991 3.44927C7.42674 3.69245 7.42664 4.08723 7.66981 4.33041Z",
    stroke: "#45436B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag1);
export default __webpack_public_path__ + "static/media/tag1.8cb7658b6be8c4663748f1cd4db9d794.svg";
export { ForwardRef as ReactComponent };